module.exports = __webpack_public_path__ + "static/media/cvworks-logo.5821ada9.svg";